import useDefaultCardFooterAction from '../default/useDefaultCardFooterAction';
const useDealCardFooterAction = args => {
  var _defaultCardFooterAct;
  const defaultCardFooterAction = useDefaultCardFooterAction(args);
  if (!defaultCardFooterAction.primaryActionConfig) {
    return defaultCardFooterAction;
  }
  const href = (_defaultCardFooterAct = defaultCardFooterAction.primaryActionConfig) === null || _defaultCardFooterAct === void 0 ? void 0 : _defaultCardFooterAct.href;
  // Filters always exist to narrow down to the specific deal, so we can add the pipelineId to the href
  const dealSpecificHref = `${href}&pipelineId=all`;
  return {
    primaryActionConfig: Object.assign({}, defaultCardFooterAction.primaryActionConfig, {
      href: dealSpecificHref
    })
  };
};
export default useDealCardFooterAction;